import { useRequest } from '@byted/hooks';
import { Scope } from '@/typings/fe';
import { forumPostService } from '@/api/forumPost';
import { OFFICIAL } from '@/consts';

const fetcher = async (scope: Scope) => {
  const res = await forumPostService.getPostsByGroup({
    Scope: scope,
  });
  if (res.error) {
    throw new Error();
  }
  return res.data;
};

export const useBulletinId = (scope?: Scope) => {
  const { data, loading } = useRequest(fetcher, {
    auto: true,
    defaultParams: [scope],
    refreshDeps: [scope],
    ready: Boolean(scope),
  });
  return {
    bulletinId: data?.List.find(item => item.Name === OFFICIAL)?.Id,
    loading,
  };
};
